import { Iconfont } from '@umu/umu-design';
import React from 'react';
import { CooperationActionWrap } from 'businessCommon/src/components/cooperationActionWrap';

interface IProps {
    value: any;
    info: any;
    config: Record<string, any>;
}
const defaultConfig = {
    iconInfo: {
        iconType: 'Complete',
        className: 'icon-complete',
    },
    labelInfo: {
        className: 'label-warning',
        title: ' ',
    },
};
const StatusLabel = (props: IProps) => {
    const { config, info, value } = props;
    const statusConfig = config?.getLabelInfo(value, info) || config?.info || defaultConfig;
    const { iconInfo, labelInfo, layout = 'vertical', staticLabelInfo } = statusConfig;

    const renderTitle = () => {
        if (labelInfo?.actionName !== '') {
            return (
                <CooperationActionWrap role={labelInfo.role} actionName={labelInfo?.actionName}>
                    <span className={labelInfo.className} {...labelInfo?.propsInfo}>
                        {labelInfo.title}
                    </span>
                </CooperationActionWrap>
            );
        }
        if (!labelInfo?.actionName) {
            return (
                <span className={labelInfo.className} {...labelInfo?.propsInfo}>
                    {labelInfo.title}
                </span>
            );
        }
        if (!!staticLabelInfo && !!staticLabelInfo?.title) {
            return <span className={staticLabelInfo?.className}>{staticLabelInfo?.title}</span>;
        }
        return null;
    };

    return (
        <div
            className={`ele-render-type-status-label-info ${
                config.className || ''
            }-status-label-info ele-render-type-status-label-info-${layout}`}
        >
            <div className="statu-icon-container">
                {iconInfo.iconClassName && <i className={`icon ${iconInfo.iconClassName}`} />}
                {iconInfo.iconType && (
                    <Iconfont
                        type={iconInfo.iconType}
                        className={`ele-render-type-status-label-info-icon ${iconInfo.className}`}
                    />
                )}
            </div>
            {renderTitle()}
        </div>
    );
};
const StatusLabelList = (props: IProps) => {
    const { config, info, value } = props;
    const list = config?.getLabelList(value, info) || [config];
    return (
        <ul className="ele-render-type-status-label-info-list">
            {list.map((item: any, index: number) => {
                return (
                    <li key={index} className="ele-render-type-status-label-info-list-item">
                        <StatusLabel config={item} info={info} value={value} />
                    </li>
                );
            })}
        </ul>
    );
};
export { StatusLabel, StatusLabelList };
